import type { IntlShape } from 'react-intl'
import { defineMessages } from 'react-intl'

import type { AvailabilityRule } from './AvailabilityRule'
import type { Moment } from './moment'

export class AvailabilityRuleFormatter {
  private now: Moment
  private formatMessage: IntlShape['formatMessage']

  constructor(now: Moment, formattMessage: IntlShape['formatMessage']) {
    this.now = now
    this.formatMessage = formattMessage
  }

  format(rule: AvailabilityRule) {
    if (rule.repeats) {
      return this.formatMessage(messages.every_week, {
        date: rule.start.format(rule.start.isSame(this.now, 'year') ? 'D MMMM' : 'D MMMM YYYY').replace(/ /, '\u00a0'),
        day: rule.start.weekday(),
        start: rule.start.format('HH:mm'),
        end: rule.end.format('HH:mm'),
      })
    }
    return this.formatMessage(messages.from_to, {
      date: rule.start.format(rule.start.isSame(this.now, 'year') ? 'D MMMM' : 'D MMMM YYYY').replace(/ /, '\u00a0'),
      start: rule.start.format('HH:mm'),
      end: rule.end.format('HH:mm'),
    })
  }
}

const messages = defineMessages({
  every_week: { id: "utils.AvailabilityRuleFormatter.messages.every_week.5e54", defaultMessage: `{day, select,
    0 {Каждый понедельник}
    1 {Каждый вторник}
    2 {Каждую среду}
    3 {Каждый четверг}
    4 {Каждую пятницу}
    5 {Каждую субботу}
    6 {Каждое воскресенье}
    other {%UNKNOWN%}
  } с\u00a0{start} до\u00a0{end} начиная с\u00a0{date}` },
  from_to: { id: "utils.AvailabilityRuleFormatter.messages.from_to.d6de", defaultMessage: '{date} с\u00a0{start} до\u00a0{end}' },
})
